import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0dee1d8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "select-professional"
}
const _hoisted_2 = { id: "nav-calendar" }
const _hoisted_3 = { class: "calendar-picker" }
const _hoisted_4 = { class: "calendar-main" }
const _hoisted_5 = { class: "calendar-nav" }
const _hoisted_6 = { class: "calendar-month-year" }
const _hoisted_7 = { class: "nav-month" }
const _hoisted_8 = { class: "six-weeks" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "week-days" }, [
  /*#__PURE__*/_createElementVNode("span", null, " D "),
  /*#__PURE__*/_createElementVNode("span", null, " S "),
  /*#__PURE__*/_createElementVNode("span", null, " T "),
  /*#__PURE__*/_createElementVNode("span", null, " Q "),
  /*#__PURE__*/_createElementVNode("span", null, " Q "),
  /*#__PURE__*/_createElementVNode("span", null, " S "),
  /*#__PURE__*/_createElementVNode("span", null, " S ")
], -1))
const _hoisted_10 = { class: "four-two" }
const _hoisted_11 = { id: "nav-main" }
const _hoisted_12 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_select_option = _resolveComponent("select-option")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.current_user?.admin)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_select_option, {
            name: 'profesisonal',
            label: 'Profissional',
            modelValue: _ctx.professional_id,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.professional_id) = $event)),
            options: _ctx.professional_options,
            empty_message: 'Nenhum profissional cadastrado'
          }, null, 8, ["modelValue", "options"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.calendar_month), 1),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", {
                class: "noselect prev-next",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setMonth(-1)))
              }, [
                _createVNode(_component_font_awesome_icon, { icon: "chevron-left" })
              ]),
              _createElementVNode("span", {
                class: "noselect prev-next",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setMonth(1)))
              }, [
                _createVNode(_component_font_awesome_icon, { icon: "chevron-right" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.six_weeks, (d) => {
                return (_openBlock(), _createBlock(_component_router_link, {
                  class: _normalizeClass(["noselect select-date", {
                'is-selected': d.isSelected,
                'out-month': d.outMonth,
                'is-today': d.isToday,
                'is-invalid-day': !d.valid_day,
              }]),
                  key: d.day + '/' + d.month + '/' + d.year,
                  to: {
                name: _ctx.period,
                params: { day: d.day, month: d.month + 1, year: d.year },
              }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(d.day), 1)
                  ]),
                  _: 2
                }, 1032, ["class", "to"]))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("nav", _hoisted_11, [
      _createElementVNode("ul", null, [
        (_ctx.current_user?.admin)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  class: "nav-link",
                  to: "/clinics"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Estabelecimentos")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  class: "nav-link",
                  to: "/specialties"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Especialidades")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  class: "nav-link",
                  to: "/professionals"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Profissionais")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  class: "nav-link",
                  to: "/schedules"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Horários")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  class: "nav-link",
                  to: "/patients"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Pacientes")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  class: "nav-link",
                  to: "/users"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Usuários")
                  ]),
                  _: 1
                })
              ])
            ], 64))
          : (_openBlock(), _createElementBlock("li", _hoisted_12, [
              _createVNode(_component_router_link, {
                class: "nav-link",
                to: "/schedules"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Meus Horários")
                ]),
                _: 1
              })
            ]))
      ])
    ])
  ], 64))
}